export default __webpack_public_path__ + "static/media/xdai.6a9ed7e3.png";